import { createFileRoute } from '@tanstack/react-router'
import { InviteAFriendPage } from '@components/InviteAFriend'

export const Route = createFileRoute('/invite')({
  component: InviteAFriendPage,
})
